import React from "react";
import PageTransition from "@/components/mobile/PageTransition";
import CloudTypesGuide from "@/components/weather/CloudTypesGuide";

export default function CloudTypes() {
  return (
    <PageTransition>
      <main className="min-h-screen bg-[radial-gradient(circle_at_12%_0%,rgba(20,184,166,0.20),transparent_28rem),linear-gradient(180deg,#F3FBFA_0%,#F8FCFB_100%)] px-4 py-8 text-slate-950 sm:px-6 md:px-8 lg:py-10">
        <div className="mx-auto w-full max-w-7xl">
          <CloudTypesGuide />
        </div>
      </main>
    </PageTransition>
  );
}